import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";

import Sidebar from "../sidebar/sidebar";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { GoogleProvider } from "../../contexts/google-context";
import { WrapperDashboard } from "../custom-components";

// pages
import Home from "../../pages/Home";
import Customers from "../../pages/Customers";
import Screenings from "../../pages/Screenings";
import PracticesCqs from "../../pages/PracticesCqs";
import PracticesLoans from "../../pages/PracticesLoans";
import PracticesDebts from "../../pages/PracticesDebts";
import Database from "../../pages/Database";
import Archives from "../../pages/Archives";
import Calendar from "../../pages/Calendar";
import Banks from "../../pages/Banks";
import ServiceScreeningDetailsPage from "../../pages/ServiceDetailsScreening";
import ServicesConfigurationPage from "../../pages/ServicesConfigurationPage";
import Activities from "../../pages/Activities";
import Users from "../../pages/Users";
import DeleteReports from "../../pages/DeleteReports";
import ServiceCustomerDetailsPage from "../../pages/ServiceCustomerDetails";
import "./dashboard.css";
import TributaryScreening from "../../pages/TributaryScreening";
import PracticesCardRetrieval from "../../pages/PracticesCardRetrieval";
import Me from "../../pages/Me";
import PracticesErogation from "../../pages/PracticesErogation";
import PracticesFinanthia from "../../pages/PracticesFinanthia";

const Dashboard = ({ signOut }) => {
  const { user } = useAuthenticator();
  const role =
    user &&
      user.signInUserSession &&
      user.signInUserSession.accessToken &&
      user.signInUserSession.accessToken.payload &&
      user.signInUserSession.accessToken.payload["cognito:groups"] &&
      user.signInUserSession.accessToken.payload["cognito:groups"].length
      ? user.signInUserSession.accessToken.payload["cognito:groups"][0]
      : "CLIENTE";
  const isBroker = role === "BROKER";

  /*
    Soluzione temporanea per avere un redirect automatico alla home nel cao in cui la route corrente non sia valida.
    Le varie guide suggeriscono di aggiungere alla fine dello switch un blocco di questo tipo:
    <Route path="*">
      <Redirect to="/home" />
    </Route>
    Ma per qualche motivo questa cosa non funziona! Da approfondire
  */
  var routes = isBroker ? ["/customers", "/me"] : [
    "/home",
    "/customers",
    "/practices-cqs",
    "/practices-cqs-legacy",
    "/practices-loans",
    "/practices-loans-legacy",
    "/practices-debts",
    "/practices-debts-legacy",
    "/database",
    "/archives",
    "/calendar",
    "/banks",
    "/users",
    "/service-screening",
    "/service-details",
    "/screenings",
    "/delete-report",
    "/services-configuration",
    "/activities",
    "/practices-card-retrieval",
    "/practices-card-retrieval-legacy",
    "/practices-finanthia",
    "/practices-erogation",
    "/me"
  ];
  var pathValid = false;
  for (var i = 0; i < routes.length; i++) {
    if (
      window.location.pathname === routes[i] ||
      window.location.pathname.startsWith(routes[i] + "/")
    ) {
      pathValid = true;
    }
  }
  if (!pathValid) {
    window.location.pathname = isBroker ? "/customers" : "/home";
  }

  return (
    <BrowserRouter>
      <WrapperDashboard>
        <Sidebar role={role} signOut={signOut} />
        <div className="wrapper-pages">
          <GoogleProvider>
            {isBroker ? (
              <Switch>
                <Route path="/customers" component={Customers} />
                <Route path="/me" component={Me} />
                <Redirect to="/customers" />
              </Switch>
            ) : (
              <Switch>
                <Route path="/customers" component={Customers} />
                <Route path="/practices-cqs" component={PracticesCqs} />
                <Route path="/practices-cqs-legacy" component={PracticesCqs} />
                <Route path="/screenings" component={Screenings} />
              <Route
                path="/tributary-screenings"
                component={TributaryScreening}
              />
              <Route path="/delete-report" component={DeleteReports} />
              <Route path="/practices-loans" component={PracticesLoans} />
              <Route
                path="/practices-loans-legacy"
                component={PracticesLoans}
              />
              <Route
                path="/practices-card-retrieval"
                component={PracticesCardRetrieval}
              />
              <Route
                path="/practices-card-retrieval-legacy"
                component={PracticesCardRetrieval}
              />
              <Route path="/practices-debts" component={PracticesDebts} />
              <Route
                path="/practices-debts-legacy"
                component={PracticesDebts}
              />
              <Route
                path="/practices-erogation"
                component={PracticesErogation}
              />
              <Route
                path="/practices-finanthia"
                component={PracticesFinanthia}
              />
              <Route path="/database" component={Database} />
              <Route path="/archives" component={Archives} />
              <Route path="/calendar" component={Calendar} />
              <Route path="/banks" component={Banks} />
              <Route path="/users" component={Users} />
              <Route
                path="/service-screening"
                component={ServiceScreeningDetailsPage}
              />
              <Route path="/me" component={Me} />
              <Route
                path="/service-details"
                component={ServiceCustomerDetailsPage}
              />
              <Route path="/home" component={Home} />
              {role === "ADMIN" ? (
                <>
                  <Route path="/users" component={Users} />
                  <Route
                    path="/services-configuration"
                    component={ServicesConfigurationPage}
                  />
                  <Route path="/activities" component={Activities} />
                </>
              ) : null}
              <Route path="*">
                <Redirect to="/home" />
              </Route>
              </Switch>
            )}
          </GoogleProvider>
        </div>
      </WrapperDashboard>
    </BrowserRouter>
  );
};

export default Dashboard;
